import React, { useState } from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, LabelList } from 'recharts';
import styles from './ChartCard.module.css';

const PERIODS = [
  { key: 'daily', label: 'Daily' },
  { key: 'weekly', label: 'Weekly' },
  { key: 'monthly', label: 'Monthly' },
];

/**
 * ChartCard — presentational component for time-series metrics.
 *
 * Props:
 *   entry    {object}  — registry entry (label, dataKeyField, cardType)
 *   cardData {object}  — { daily: [...], weekly: [...], monthly: [...] }
 *   metricId {string}  — string key from registry
 */
const ChartCard = ({ entry, cardData, metricId }) => {
  const [period, setPeriod] = useState('monthly');

  const dataField = entry.dataKeyField || 'count';
  const periodData = cardData[period] || [];

  return (
    <div className={styles.card} data-testid={`chart-card-${metricId}`}>
      <div className={styles.header}>
        <span className={styles.label}>{entry.label}</span>
        <div className={styles.toggleGroup}>
          {PERIODS.map(({ key, label }) => (
            <button
              key={key}
              className={period === key ? styles.toggleBtnActive : styles.toggleBtn}
              onClick={() => setPeriod(key)}
            >
              {label}
            </button>
          ))}
        </div>
      </div>

      {periodData.length === 0 ? (
        <div className={styles.emptyMessage}>No data for this period</div>
      ) : (
        <ResponsiveContainer width="100%" height={250}>
          <BarChart data={periodData}>
            <XAxis dataKey="date" tick={{ fill: '#ffffff', fontSize: 11 }} />
            <YAxis tick={{ fill: '#ffffff', fontSize: 11 }} />
            <Tooltip />
            <Bar dataKey={dataField} fill="#FF8303">
              <LabelList dataKey={dataField} position="top" fill="white" fontSize={11} />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default ChartCard;
